import { news } from "@/mocks/news";

export default function News() {
  return (
    <section
      id="news"
      className="relative w-full py-24 md:py-32 bg-background-50 border-t border-background-200/60"
    >
      <div className="w-full px-6 md:px-10 max-w-[1600px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                NEWS / FIELD REPORT
              </span>
            </div>
            <h4
              className="text-foreground-950 text-5xl md:text-7xl leading-[0.9]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <a href="#news" className="hover:text-primary-500 transition-colors cursor-pointer">
                最新のフィールド<span className="text-primary-500">.</span>
              </a>
            </h4>
          </div>
          <a
            href="#news"
            className="inline-flex items-center gap-3 text-foreground-800 hover:text-primary-500 text-xs tracking-[0.3em] cursor-pointer"
            style={{ fontFamily: "var(--font-label)" }}
          >
            すべて見る <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {news.map((n) => (
            <article
              key={n.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-500/60 transition"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  title={`${n.title} 雷撃カゴ`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ objectPosition: n.objectPosition }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] tracking-[0.3em] px-2 py-1 rounded-sm bg-primary-500 text-background-50">
                    {n.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <div className="text-[11px] text-foreground-9500 tracking-widest mb-3">
                  {n.date}
                </div>
                <h4
                  className="text-foreground-950 text-lg md:text-xl leading-snug mb-3"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  <a href={`#news-${n.id}`} className="hover:text-primary-500 transition-colors cursor-pointer">
                    {n.title}
                  </a>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed flex-1">
                  {n.excerpt}
                </p>
                <div className="mt-5 flex items-center gap-2 text-primary-500 text-xs tracking-[0.3em]">
                  READ MORE <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}